import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from '@mui/system';

export const EntryToolTip = styled(({ className, ...props }) => (
  <Tooltip
    arrow
    placement="bottom" // Initial placement
    PopperProps={{
      modifiers: [
        {
          name: 'flip',
          enabled: true, // Allow flipping
          options: {
            altBoundary: true, // Flip relative to the viewport, not just the container
            rootBoundary: 'viewport',
            padding: 30, // Adds space between the tooltip and the viewport boundary
          },
        },
      ],
    }}
    {...props}
    classes={{ popper: className }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "#fff",
    fontSize: 13,
    padding: "0",
    [theme.breakpoints.up('sm')]: {
      minWidth: "450px", // Min width of 450px for devices 450px and above
    },
    [theme.breakpoints.up('md')]: {
      minWidth: "750px", // Min width of 450px for devices 450px and above
    },
  },
}));

